var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"overflow-hidden",attrs:{"name":"slide-down","mode":_vm.dataMode,"appear":""},on:{"enter":_vm.enter,"leave":_vm.leave,"after-enter":function($event){return _vm.$emit('entered')},"after-leave":function($event){return _vm.$emit('left')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }